"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = void 0;
const chains_1 = require("viem/chains");
var ChainId;
(function (ChainId) {
    ChainId[ChainId["Ethereum"] = chains_1.mainnet.id] = "Ethereum";
    ChainId[ChainId["EthereumSepolia"] = chains_1.sepolia.id] = "EthereumSepolia";
    ChainId[ChainId["Polygon"] = chains_1.polygon.id] = "Polygon";
    ChainId[ChainId["PolygonMumbai"] = chains_1.polygonMumbai.id] = "PolygonMumbai";
    ChainId[ChainId["Base"] = chains_1.base.id] = "Base";
    ChainId[ChainId["BaseSepolia"] = chains_1.baseSepolia.id] = "BaseSepolia";
})(ChainId || (exports.ChainId = ChainId = {}));
